export class AnnualPricing {
  teamBusinessPlan: string = '67';
  soloBusinessPlan: string = '40';
  teamProfessionalPlan: string = '35';
  soloProfessionalPlan: string = '22';
  teamBusinessAddOns: string = '22.50';
  teamProfessionalAddOns: string = '13.50';
}
